import CreateTestimonyContainer from "../containers/CreateTestimonyContainer";

const CreateTestimonyPage = () => {
  return (
    <CreateTestimonyContainer />
  );
};

export default CreateTestimonyPage;
